/**
 * Details of tasks who run periodically in backend.
 */
export class TaskDetails {
  type: string;
  status: string;
  lastComplete: string;

  /**
   * @param type the type of the task.
   * @param status the status of the task.
   * @param lastComplete the last time the task was completed successfully.
   */
  constructor(type: string, status: string, lastComplete: string) {
    this.type = type;
    this.status = status;
    this.lastComplete = lastComplete;
  }
}
